import React from "react"
import { Box } from "@mui/material"
import MojsExample from "../assets/animations/hyrisLoader"

export const Loading = (): React.ReactElement => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="500px">
      <MojsExample duration={2000} />
    </Box>
  )
}
